module.exports = __webpack_public_path__ + "img/202627_u_fr.18a609e0.png";